import styles from "./Certificate.module.css";

export const Certificate = () => {
	return <div>Certificate</div>;
};
